import { c as _c } from "react/compiler-runtime";
// Mobile-only 1px spacer between the Vaults and Variable Rate Markets sections, shared with the
// portfolio route loading state so the sections below it start at the same height.
const DashboardSectionDivider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="h-px w-full lg:hidden" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DashboardSectionDivider;